import { Executive } from '../types';

export const executives: Executive[] = [
  {
    id: 'ceo',
    title: 'Chief Executive Officer',
    initials: 'CEO',
    gradient: 'linear-gradient(45deg, #003366, #00CC99)',
    problemCategories: [
      {
        id: 'ceo-1',
        title: 'Strategic Planning',
        description: 'Long-term vision and strategic roadmap development.',
        problemCount: 15,
        icon: 'business'
      },
      {
        id: 'ceo-2',
        title: 'Growth Management',
        description: 'Scaling operations and market expansion strategies.',
        problemCount: 12,
        icon: 'business'
      },
      {
        id: 'ceo-3',
        title: 'Board Relations',
        description: 'Stakeholder management and governance.',
        problemCount: 8,
        icon: 'business'
      }
    ],
    surrogates: [
      {
        id: 'ceo-s1',
        name: 'Strategic AI Advisor',
        type: 'ai',
        coreSkills: ['Strategic Analysis', 'Market Intelligence', 'Risk Assessment'],
        automationCapability: 9,
        efficiency: 8
      },
      {
        id: 'ceo-s2',
        name: 'Executive Coach',
        type: 'human',
        coreSkills: ['Leadership Development', 'Change Management', 'Board Relations'],
        automationCapability: 7,
        efficiency: 9
      }
    ]
  },
  {
    id: 'cto',
    title: 'Chief Technology Officer',
    initials: 'CTO',
    gradient: 'linear-gradient(45deg, #00CC99, #8A2BE2)',
    problemCategories: [
      {
        id: 'cto-1',
        title: 'Tech Innovation',
        description: 'Emerging technology adoption and implementation.',
        problemCount: 18,
        icon: 'ai'
      },
      {
        id: 'cto-2',
        title: 'Infrastructure',
        description: 'Scalable and secure system architecture.',
        problemCount: 14,
        icon: 'security'
      },
      {
        id: 'cto-3',
        title: 'Tech Strategy',
        description: 'Technology roadmap and resource planning.',
        problemCount: 10,
        icon: 'business'
      }
    ],
    surrogates: [
      {
        id: 'cto-s1',
        name: 'Tech Architecture AI',
        type: 'ai',
        coreSkills: ['System Design', 'Tech Stack Analysis', 'Performance Optimization'],
        automationCapability: 9,
        efficiency: 9
      },
      {
        id: 'cto-s2',
        name: 'Senior Solutions Architect',
        type: 'human',
        coreSkills: ['Enterprise Architecture', 'Cloud Infrastructure', 'Security'],
        automationCapability: 8,
        efficiency: 9
      }
    ]
  },
  {
    id: 'cfo',
    title: 'Chief Financial Officer',
    initials: 'CFO',
    gradient: 'linear-gradient(45deg,  #003366, #8A2BE2)',
    problemCategories: [
      {
        id: 'cfo-1',
        title: 'Financial Planning',
        description: 'Budget allocation and financial forecasting.',
        problemCount: 12,
        icon: 'business'
      },
      {
        id: 'cfo-2',
        title: 'Risk Management',
        description: 'Financial risk assessment and mitigation.',
        problemCount: 9,
        icon: 'security'
      },
      {
        id: 'cfo-3',
        title: 'Investment Strategy',
        description: 'Capital allocation and investment planning.',
        problemCount: 7,
        icon: 'business'
      }
    ],
    surrogates: [
      {
        id: 'cfo-s1',
        name: 'Financial Analysis AI',
        type: 'ai',
        coreSkills: ['Financial Modeling', 'Risk Analysis', 'Market Prediction'],
        automationCapability: 9,
        efficiency: 8
      },
      {
        id: 'cfo-s2',
        name: 'Financial Advisor',
        type: 'human',
        coreSkills: ['Investment Strategy', 'Risk Management', 'Corporate Finance'],
        automationCapability: 7,
        efficiency: 9
      }
    ]
  },
  {
    id: 'cpo',
    title: 'Chief Product Officer',
    initials: 'CPO',
    gradient: 'linear-gradient(45deg, #00CC99, #8A2BE2)',
    problemCategories: [
      {
        id: 'cpo-1',
        title: 'Product Strategy',
        description: 'Product roadmap and vision planning.',
        problemCount: 17,
        icon: 'business'
      },
      {
        id: 'cpo-2',
        title: 'Innovation',
        description: 'Product innovation and development.',
        problemCount: 15,
        icon: 'ai'
      },
      {
        id: 'cpo-3',
        title: 'User Experience',
        description: 'Customer experience and product design.',
        problemCount: 12,
        icon: 'business'
      }
    ],
    surrogates: [
      {
        id: 'cpo-s1',
        name: 'Product Innovation AI',
        type: 'ai',
        coreSkills: ['Product Analytics', 'Feature Prediction', 'User Behavior Analysis'],
        automationCapability: 9,
        efficiency: 8
      },
      {
        id: 'cpo-s2',
        name: 'Product Strategy Lead',
        type: 'human',
        coreSkills: ['Product Management', 'UX Design', 'Market Research'],
        automationCapability: 8,
        efficiency: 9
      }
    ]
  },
  {
    id: 'cmo',
    title: 'Chief Marketing Officer',
    initials: 'CMO',
    gradient: 'linear-gradient(45deg, #8A2BE2, #FF6F00)',
    problemCategories: [
      {
        id: 'cmo-1',
        title: 'Market Analysis',
        description: 'Market research and customer insights.',
        problemCount: 14,
        icon: 'business'
      },
      {
        id: 'cmo-2',
        title: 'Brand Strategy',
        description: 'Brand development and positioning.',
        problemCount: 11,
        icon: 'business'
      },
      {
        id: 'cmo-3',
        title: 'Digital Marketing',
        description: 'Digital transformation and marketing tech.',
        problemCount: 9,
        icon: 'ai'
      }
    ],
    surrogates: [
      {
        id: 'cmo-s1',
        name: 'Marketing Analytics AI',
        type: 'ai',
        coreSkills: ['Market Analysis', 'Customer Segmentation', 'Campaign Optimization'],
        automationCapability: 9,
        efficiency: 8
      },
      {
        id: 'cmo-s2',
        name: 'Marketing Strategist',
        type: 'human',
        coreSkills: ['Brand Strategy', 'Market Research', 'Digital Marketing'],
        automationCapability: 7,
        efficiency: 9
      }
    ]
  },
  {
    id: 'cro',
    title: 'Chief Risk Officer',
    initials: 'CRO',
    gradient: 'linear-gradient(45deg, #FF6F00,  #8A2BE2)',
    problemCategories: [
      {
        id: 'cro-1',
        title: 'Risk Assessment',
        description: 'Enterprise risk identification and analysis.',
        problemCount: 16,
        icon: 'security'
      },
      {
        id: 'cro-2',
        title: 'Compliance',
        description: 'Regulatory compliance and governance.',
        problemCount: 13,
        icon: 'security'
      },
      {
        id: 'cro-3',
        title: 'Security Strategy',
        description: 'Information security and risk mitigation.',
        problemCount: 11,
        icon: 'security'
      }
    ],
    surrogates: [
      {
        id: 'cro-s1',
        name: 'Risk Analysis AI',
        type: 'ai',
        coreSkills: ['Risk Modeling', 'Threat Detection', 'Compliance Monitoring'],
        automationCapability: 9,
        efficiency: 9
      },
      {
        id: 'cro-s2',
        name: 'Risk Management Expert',
        type: 'human',
        coreSkills: ['Enterprise Risk', 'Compliance', 'Crisis Management'],
        automationCapability: 8,
        efficiency: 9
      }
    ]
  },
]; 